import gql from "graphql-tag"

export const GET_DEPENDENCIES = gql`
  query gatsbyDependenciesForSite($siteId: UUID!) {
    gatsbyDependenciesForSite(siteId: $siteId) {
      name
      installedVersion
    }
  }
`
export const SATISFIES_DEPENDENCY_RANGE = gql`
  query siteSatisfiesDependencyRange(
    $siteId: UUID!
    $dependencyName: String!
    $dependencyRange: String!
  ) {
    siteSatisfiesDependencyRange(
      siteId: $siteId
      dependencyName: $dependencyName
      dependencyRange: $dependencyRange
    )
  }
`
